import { render } from "./Accessibility-statement.component.html?vue&type=template&id=a6722f60&ts=true&external"
import script from "./Accessibility-statement.component.ts?vue&type=script&lang=ts&external"
export * from "./Accessibility-statement.component.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__